export const USER = "USER";
export const PASSWORD = "PASSWORD";
export const USER_UPDATE = "USER_UPDATE";
export const NOTIFICATION = "NOTIFICATION";
export const EMAIL_SIGNATURE = "EMAIL_SIGNATURE";

export const FETCH = "FETCH";
export const UPDATE = "UPDATE";
export const CREATE = "CREATE";
export const DELETE = "DELETE";

export const CAPABILITIES = "CAPABILITIES";
export const USERS = "USERS";
export const CONTENT_MODERATORS = "CONTENT_MODERATORS";
export const ACTIVITY_EVENTS = "ACTIVITY_EVENTS";

export const INTEGRATIONS = "INTEGRATIONS";

export const ADOPTION = "ADOPTION";
export const TRACK = "TRACK";
export const IDENTIFY = "IDENTIFY";

export const ACCOUNT = "ACCOUNT";

export const UPLOAD = "UPLOAD";
export const MEDIA = "MEDIA";
export const ACTIVATION = "ACTIVATION";
export const CUSTOM_FIELDS = 'CUSTOM_FIELDS';
export const CUSTOM_FIELD_CREATE = 'CUSTOM_FIELD_CREATE';
export const CUSTOM_FIELD_UPDATE = 'CUSTOM_FIELD_UPDATE';
export const CUSTOM_FIELD_DELETE = 'CUSTOM_FIELD_DELETE';
export const CUSTOM_FIELD_ORDER = 'CUSTOM_FIELD_ORDER';

export const USER_ROLES = 'USER_ROLES';
export const DATA_SOURCE = "DATA_SOURCE";
export const MIGRATE = "MIGRATE";
export const RSS = "RSS";
export const AUTHENTICATE = "AUTHENTICATE";
export const STORAGE_LIMIT = "STORAGE_LIMIT";
export const ACTION_NEEDED = "ACTION_NEEDED";
export const KEYS = "KEYS";

export const STREAM_ACCESS = "STREAM_ACCESS";
export const STREAM_ANALYTICS = "STREAM_ANALYTICS";
export const MANAGE_ACCESS = "MANAGE_ACCESS";

export const VIEWER_SETTINGS = "VIEWER_SETTINGS";

//hubspot
export const HUBSPOT_PIPELINES = "HUBSPOT_PIPELINES";
